<template>
  <b-modal
    :id="id"
    :title="modalTitle"
    :hide-footer="true"
    size="lg"
  >
    <template v-if="studentProfileUrls.length === 0">
      表示できるプロフィールがありません。
    </template>
    <template v-else>
      <Pagenation
        :index="profileIndex"
        :total="studentProfileUrls.length"
        :isDetail="false"
        @showOther="showOther"
      >
      </Pagenation>
      <PersonalProfile
        :url_string="selectedUrlString"
      />
    </template>
  </b-modal>
</template>

<script>

import Pagenation from '@/components/Pagenation.vue'
import PersonalProfile from '@/components/PersonalProfile.vue'
import { mapState } from 'vuex'

export default {
  name: 'ProfileModal',
  components: {
    PersonalProfile,
    Pagenation
  },

  props: {
    id: {
      type: String,
      default: 'profile-modal'
    },
    modalTitle: {
      type: String,
      default: 'プロフィール'
    },
    clickedUrlString: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      profileUrlString: '',
      profileIndex: 0
    }
  },
  computed: {
    ...mapState({
      studentProfileUrls: state => state.Announcement.studentProfileUrls
    }),
    selectedUrlString() {
      return this.studentProfileUrls[this.profileIndex].url_string
    }
  },

  methods: {
    showOther(index) {
      if (index >= this.studentProfileUrls.length) {
        index = this.studentProfileUrls.length - 1
      }
      this.profileIndex = index
    },
    getIndexByUrlString(urlString) {
      return this.studentProfileUrls.findIndex((item) => item.url_string === urlString)
    }
  },
  watch: {
    clickedUrlString() {
      this.profileIndex = this.getIndexByUrlString(this.clickedUrlString)
    }
  }
}
</script>
